document.querySelectorAll('.pamphlets__card').forEach((link) => {
  link.addEventListener('click', function () {
    const id = this.dataset.id;

    fetch(`/pamphlet/${id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content,
      },
    });
  });
});
